import { TAGS } from "../constants";
import { Role } from "../types";
import { api } from "./api";

export const rolesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query<Role[], void>({
      query: () => ({
        url: `/api/roles`,
        method: "GET",
      }),
      providesTags: [TAGS.ROLES],
    }),
  }),
});

export const { useGetRolesQuery } = rolesApi;
